<template>
  <div id="app">
    <ErrorBoundary>
      <router-view />
    </ErrorBoundary>
    <my-ModelBox :isShow="showSuccessBind" @hide="showSuccessBinBox">
      <SuccessBindBox @hide="showSuccessBinBox"></SuccessBindBox>
    </my-ModelBox>
  </div>
</template>
<script>
import SuccessBindBox from "@/components/OverallSituationModel/BOX/SuccessBindBox.vue";
import ErrorBoundary from "@/components/Error/ErrorBoundary.vue";
export default {
  components: {
    ErrorBoundary,
    SuccessBindBox,
  },
  name: "App",
  computed: {
    showSuccess() {
      return this.$store.state.staking.showSuccessBind;
    },
  },
  watch: {
    showSuccess(newValue) {
      this.showSuccessBind = newValue;
    },
  },
  data() {
    return {

      showSuccessBind: false, //成功制作盒子后打开
    };
  },
  methods: {
   
    showSuccessBinBox() {
      this.showSuccessBind = !this.showSuccessBind;
      this.$store.state.staking.showSuccessBind=!this.$store.state.staking.showSuccessBind
    },
  },
};
</script>
<style lang="scss">
@import "../node_modules/reset-css/reset.css";
@font-face {
  src: url("@/assets/font/HarmonyOS_Sans_SC_Bold.ttf");
  font-family: "HarmonyOS_Sans_SC_Bold";
}
body {
}
#app {
  text-align: center;
  font-family: HarmonyOS_Sans_SC_Bold;
  color: #2c3e50;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
* {
  user-select: none;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
input {
  -webkit-user-select: auto;
}
textarea {
  -webkit-user-select: auto;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
